import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import { select, Store } from '@ngrx/store';
import clone from 'just-clone';
import moment from 'moment';
import { Observable, ReplaySubject } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';
import * as fromDataServices from '../../../data-services';
import * as fromShared from '../../../shared';
import { LoggingService } from '../../../shared/services/logging';
import { getUserInfo, IUserInfo } from '../../../user-info';
import * as fromStore from '../../management/store';
@Component({
    selector: 'ef-invoice-session-number-container',
    templateUrl: './invoice-session-number-container.component.html',
    styleUrls: ['./invoice-session-number-container.component.scss'],
    standalone: false
})
export class InvoiceSessionNumberContainerComponent
    implements OnInit, OnDestroy
{
    sessions$: Observable<fromStore.SessionNumber.InvoiceSessionNumber[]>;
    filterFormGroup: UntypedFormGroup;
    moment: any;
    maxDate: Date = new Date();
    startDate: Date;
    endDate: Date;
    selectedContracts: any;
    contracts$: Observable<
        fromDataServices.InvoiceContractCycle.InvoiceContractCycleModel[]
    >;
    filteredContracts$: Observable<
        fromDataServices.InvoiceContractCycle.InvoiceContractCycleModel[]
    >;

    filterChangedSubject = new ReplaySubject<{
        startDate: Date;
        endDate: Date;
        contractListID: string[];
    }>(1);
    contractsSelectItems$: Observable<fromShared.SelectItem[]>;
    invoiceContractCycleDataService: EntityCollectionService<fromDataServices.InvoiceContractCycle.InvoiceContractCycleModel>;
    selectInvoiceSubject = new ReplaySubject<fromStore.Invoice.Invoice>(1);
    process$: Observable<fromShared.Process>;
    process: fromShared.Process;
    private active = true;
    contractListIds: string[] = [];
    userInfo$: Observable<IUserInfo>;
    userInfo: IUserInfo;
    modifiedItem: fromStore.SessionNumber.InvoiceSessionNumber;
    constructor(
        private log: LoggingService,
        private store: Store,
        public entityServices: EntityServices
    ) {
        this.moment = moment;
        this.invoiceContractCycleDataService =
            entityServices.getEntityCollectionService<fromDataServices.InvoiceContractCycle.InvoiceContractCycleModel>(
                fromDataServices.InvoiceContractCycle.entityName
            );

        // this.startDate = moment(
        //     moment().add(-1, 'months').format('MM/01/YYYY')
        // ).toDate();
        // this.endDate = new Date();
        this.filterFormGroup = new UntypedFormGroup({
            startDate: new UntypedFormControl(null, Validators.required),
            endDate: new UntypedFormControl(null, Validators.required),
            ContractListID: new UntypedFormControl(null)
            // invoicesOnly: new FormControl(false)
        });
    }

    ngOnInit(): void {
        this.store.dispatch(
            fromStore.SessionNumber.clearInvoiceSessionNumbers()
        );
        this.invoiceContractCycleDataService.clearCache();
        this.invoiceContractCycleDataService.getAll();
        this.setupObservables();
        this.setupSubscriptions();
        if (this.userInfo) {
            if (
                moment(new Date(this.userInfo.LastInvoiceStart)).isValid() &&
                moment(new Date(this.userInfo.LastInvoiceEnd)).isValid()
            ) {
                this.startDate = new Date(this.userInfo.LastInvoiceStart);
                this.endDate = new Date(this.userInfo.LastInvoiceEnd);
            }
            // if (this.process.ProcessID == 121) {
            //     this.store.dispatch(
            //         fromStore.SessionNumber.getInvoiceSessionNumbers({
            //             ScheduledStartDate: this.userInfo.LastInvoiceStart,
            //             ScheduledEndDate: this.userInfo.LastInvoiceEnd,
            //             ContractListID: [],
            //             ContractDesc: [],
            //             //showInactive: true,
            //             showInvoicesOnly: true,
            //             DateRangeView: false
            //         })
            //     );
            // } else {
            //     this.store.dispatch(
            //         fromStore.SessionNumber.getInvoiceSessionNumbers({
            //             ScheduledStartDate: this.userInfo.LastInvoiceStart,
            //             ScheduledEndDate: this.userInfo.LastInvoiceEnd,
            //             ContractListID: [],
            //             ContractDesc: [],
            //             //showInactive: true,
            //             showInvoicesOnly: true,
            //             DateRangeView: true
            //         })
            //     );
            // }
        }
    }
    ngOnDestroy(): void {
        this.active = false;
        this.log.verbose('InvoiceSessionNumberContainerComponent:destroy');
    }
    setupObservables() {
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));
        this.userInfo$ = this.store.pipe(select(getUserInfo));
        this.sessions$ = this.store.pipe(
            select(fromStore.SessionNumber.selectAll),
            // skip(1), // first one is [] from the store being initialized
            map(x => clone(x)),
            map(items =>
                items.map(item => ({
                    ...item,
                    VoucherNumber:
                        item.VoucherNumber !== null
                            ? parseFloat(`${item.VoucherNumber}`)
                            : null,
                    InvoiceNbr:
                        item.InvoiceNbr !== null ? item.InvoiceNbr : null
                }))
            )
        );
        this.contracts$ = this.invoiceContractCycleDataService.entities$.pipe(
            map(
                contracts =>
                    clone(
                        contracts
                    ) as fromDataServices.InvoiceContractCycle.InvoiceContractCycleModel[]
            )
        );
        this.contractsSelectItems$ = this.contracts$.pipe(
            map(contracts =>
                contracts.map(contract => ({
                    label: contract.ContractDesc,
                    value: contract.ContractListID
                }))
            ),
            map(contracts =>
                contracts.sort((a, b) => a.label.localeCompare(b.label))
            )
        );
    }
    setupSubscriptions() {
        this.sessions$
            .pipe(takeWhile(() => this.active))
            .subscribe(sessions => {
                const arr = [];
                if (this.modifiedItem != null) {
                    sessions.forEach(session => {
                        if (session.ListID == this.modifiedItem.ListID) {
                            arr.push(session);
                        }
                    });
                    const sessionEnd = moment(
                        this.modifiedItem.SessionEnd
                    ).format('MM/DD/YYYY');
                    let index;
                    let newRow;
                    if (arr.length > 0) {
                        arr.forEach(ele => {
                            if (
                                new Date(ele.SessionStart).getTime() ==
                                    new Date(
                                        this.modifiedItem.SessionStart
                                    ).getTime() &&
                                new Date(ele.SessionEnd).getTime() ==
                                    new Date(sessionEnd).getTime() &&
                                +ele.Ib_id > +this.modifiedItem.Ib_id
                            ) {
                                newRow = ele;
                                this.log.verbose('new combined row', ele);
                            }
                        });
                        arr.forEach(ele => {
                            if (
                                new Date(ele.SessionStart) >=
                                    new Date(newRow.SessionStart) &&
                                new Date(ele.SessionEnd) <=
                                    new Date(newRow.SessionEnd)
                            ) {
                                if (ele != newRow) {
                                    index = sessions.findIndex(x => x == ele);
                                    this.store.dispatch(
                                        fromStore.SessionNumber.deleteInvoiceSessionNumbers(
                                            { ids: [+sessions[index].Ib_id] }
                                        )
                                    );
                                    sessions.splice(index, 1);
                                }
                            }
                        });
                    }
                }
                this.modifiedItem = null;
            });
        this.process$.pipe(takeWhile(() => this.active)).subscribe(process => {
            this.process = process;
        });
        this.userInfo$
            .pipe(takeWhile(() => this.active))
            .subscribe(userInfo => {
                this.userInfo = userInfo;
            });
        this.filterFormGroup.valueChanges
            .pipe(takeWhile(() => this.active))
            .subscribe(filter => {
                if (this.filterFormGroup.valid) {
                    this.log.verbose({
                        type: 'InvoiceRenumberingContainerComponent:filterFormGroup.valueChanges',
                        filter
                    });
                    if (this.process.ProcessID == 121) {
                        this.store.dispatch(
                            fromStore.SessionNumber.getInvoiceSessionNumbers({
                                ScheduledStartDate: filter.startDate,
                                ScheduledEndDate: filter.endDate,
                                ContractListID: filter.ContractListID,
                                ContractDesc: [],
                                // showInactive: true,
                                showInvoicesOnly: true,
                                DateRangeView: false
                            })
                        );
                    } else {
                        this.store.dispatch(
                            fromStore.SessionNumber.getInvoiceSessionNumbers({
                                ScheduledStartDate: filter.startDate,
                                ScheduledEndDate: filter.endDate,
                                ContractListID: filter.ContractListID,
                                ContractDesc: [],
                                // showInactive: true,
                                showInvoicesOnly: true,
                                DateRangeView: true
                            })
                        );
                    }
                }
            });
    }
    onSaveSession(items: fromStore.SessionNumber.InvoiceSessionNumber[]) {
        this.log.verbose({
            type: 'InvoiceRenumberingContainerComponent:onSaveSession',
            items
        });
        this.modifiedItem = items[0];
        this.store.dispatch(
            fromStore.SessionNumber.putInvoiceSessionNumbers({
                sessions: items
            })
        );
    }
    onDeleteInvoiceSessions($event) {
        const filter = this.filterFormGroup.value;
        if (!this.filterFormGroup.valid || !this.process) {
            this.store.dispatch(
                fromStore.SessionNumber.removeInvoiceSessionNumbers({ ids: $event })
            );
            return;
        }
        const refetchFilter = {
            ScheduledStartDate: filter.startDate,
            ScheduledEndDate: filter.endDate,
            ContractListID: filter.ContractListID ?? [],
            ContractDesc: [],
            showInvoicesOnly: true,
            DateRangeView: this.process.ProcessID !== 121
        };
        this.store.dispatch(
            fromStore.SessionNumber.removeInvoiceSessionNumbers({
                ids: $event,
                refetchFilter
            })
        );
    }
}
